import React, { useCallback } from "react";
import { FAQContent } from "../../../domain/faq/FAQContent";
import { FAQTitle } from "../../../domain/faq/FAQTitle";
import { useAppDispatch } from "../../../state/store";
import { registerFAQAction } from "../../../state/usecase/faq/action";
import { BackButton } from "../common/button/BackButton";
import { FAQInput } from "./components/FAQInput";

export function FAQAddPage() {
    const dispatch = useAppDispatch();

    const handleRegisterClicked = useCallback((title: string, content: string) => {

        dispatch(
            registerFAQAction({
                requestData: {
                    title: FAQTitle.fromString(title),
                    content: FAQContent.fromString(content)
                }
            })
        );
    }, [dispatch]);

    return (
        <div className={"faq_add_page"}>
            <div className={"container"}>
                <BackButton />
                <p className={"header"}>FAQの追加</p>
                <FAQInput 
                    initialTitle={""} 
                    initialContent={""} 
                    handleButtonClicked={function (title: string, content: string): void {
                        handleRegisterClicked(title, content);
                    }} 
                    buttonLabel={"登録"}                
                />
            </div>
        </div>
    );
}
